import { ApplicationForm } from '@/../../common/src/utils/nativeApi/interface';

export interface H5ApplicationFormSessionAdapter {
  read: () => ApplicationForm | undefined;
  write: (applicationForm: ApplicationForm) => void;
  clear: () => void;
  flush: () => Promise<unknown>;
}

export interface H5ApplicationFormSession {
  activate: (applicationForm: ApplicationForm | undefined) => Promise<void>;
  clearAndFlush: () => Promise<void>;
  isFullForm: () => boolean;
}

export const createH5ApplicationFormSession = (
  adapter: H5ApplicationFormSessionAdapter
): H5ApplicationFormSession => ({
  async activate(applicationForm) {
    if (applicationForm === undefined) {
      adapter.clear();
    } else {
      adapter.write(applicationForm);
    }
    await adapter.flush();
  },
  async clearAndFlush() {
    adapter.clear();
    await adapter.flush();
  },
  isFullForm() {
    return adapter.read() === ApplicationForm.FULL_FORM;
  },
});
